export class Translation extends Array{
    constructor(titleIt,titleEn){
        super({'language':'it','text':titleIt || ''},{'language':'en','text':titleEn || ''})
    }
}
